// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");

var subscribeJs = (
function subscribe(graphqlClient, query, handler) {
  return graphqlClient.subscribe(query).subscribe({
    next: function (result) {
      handler(result);
    }
  });
}
  );

function subscribe(graphqlClient, query, receiver) {
  return Curry._3(subscribeJs, graphqlClient, query, (function (result) {
                return Curry._1(receiver, result.data);
              }));
}

function unsubscribe(subscription) {
  return subscription.unsubscribe();
}

exports.subscribeJs = subscribeJs;
exports.subscribe = subscribe;
exports.unsubscribe = unsubscribe;
/* subscribeJs Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/graphqlSubscription.re
// module id = 1678
// module chunks = 0